import React from "react";
import { useTranslation } from "react-i18next";
import { artistUser } from "../data/data";
import { LinkIcon } from "./LinkIcon";

export function AppFooter() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-canvas-200/60 bg-canvas-100/50">
      <div className="section-container py-12 sm:py-16">
        <div className="flex flex-col items-center gap-8">
          <div className="text-center">
            <p className="font-display text-2xl font-semibold text-canvas-950">
              {t("common.artistName")}
            </p>
            <p className="mt-1 text-sm text-canvas-600">{t("footer.tagline")}</p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3">
            {artistUser.links.map(({ URL, label }) => (
              <a
                key={label}
                href={URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t(`links.labels.${label}`)}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-canvas-600 shadow-sm ring-1 ring-canvas-200/60 transition-all duration-300 hover:bg-canvas-900 hover:text-white hover:ring-canvas-900"
              >
                <LinkIcon label={label} className="h-5 w-5" />
              </a>
            ))}
          </div>

          <div className="flex flex-col items-center gap-2 text-center text-xs text-canvas-500">
            <p>
              &copy; {currentYear} {t("common.artistName")}.{" "}
              {t("footer.rights")}
            </p>
            <p>
              {t("footer.commission")}{" "}
              <a
                href={`mailto:${t("common.email")}`}
                className="text-accent hover:underline"
              >
                {t("common.email")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
